import { render } from "./News07.vue?vue&type=template&id=6bbb4194"
import script from "./News07.vue?vue&type=script&lang=js"
export * from "./News07.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__